"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _find = _interopRequireDefault(require("lodash/find"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Notification = _interopRequireDefault(require("./Notification"));
var _NotificationPropTypes = _interopRequireDefault(require("./NotificationPropTypes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class NotificationContainer extends _react.Component {
  constructor(props) {
    super(props);
    const {
      notification
    } = props;
    this.state = {
      currentNotification: notification
    };
    this._notificationQueue = [];
    if (notification) {
      this._notificationQueue.push(notification);
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      notification,
      onQueueEmpty
    } = this.props;
    this._checkQueue();
    if (prevState.currentNotification && !this.state.currentNotification && !this._notificationQueue.length && onQueueEmpty) {
      onQueueEmpty();
    } else if (notification && !(0, _find.default)(this._notificationQueue, {
      id: notification.id
    }) // eslint-disable-line react/prop-types
    ) {
      // eslint-disable-line react/prop-types
      this._notificationQueue.push(notification);
      this._checkQueue();
    }
  }
  _onRemove = () => {
    this._notificationQueue.shift();

    // clear the state first so that it causes a re-render and the queue can be re-checked
    this.setState({
      currentNotification: null
    });
  };
  _checkQueue() {
    if (this.state.currentNotification || !this._notificationQueue.length) {
      return;
    }
    this.setState({
      currentNotification: this._notificationQueue[0]
    });
  }
  render() {
    const {
      className
    } = this.props;
    const {
      currentNotification
    } = this.state;
    const classes = (0, _classnames.default)('NotificationContainer', className);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, currentNotification && /*#__PURE__*/_react.default.createElement(_Notification.default, (0, _extends2.default)({
      onRemove: this._onRemove
    }, currentNotification)));
  }
}
exports.default = NotificationContainer;